@if (crumbs().length > 0) {
  <div class="breadcrumbs">
    @for (item of crumbs(); track item.label; let first = $first) {
      @if (!first) {
        <span class="sep">/</span>
      }
      @if (item.path) {
        <a [routerLink]="item.path">{{ item.label }}</a>
      } @else {
        <span class="current">{{ item.label }}</span>
      }
    }
  </div>
}
